import type { ICaptureSourceData } from '@/plugins/cad/module/CADModule/auxiliaryTool/captureHelper'
import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/** 射线实体 */
export class RayEntity extends BaseEntity {
  /** 射线起点 */
  startPoint!: IPoint
  /** 射线方向的单位向量 */
  unitVector!: IPoint

  protected readonly serializeKeys: string[] = ['startPoint', 'unitVector']

  constructor(data: Partial<RayEntity>) {
    super(EntityType.Ray)
    Object.assign(this, data)
  }

  /**
   * 获取捕捉数据，仅返回射线起点。
   *
   * @returns 仅包含起点的捕捉数据
   */
  getCaptureData(): ICaptureSourceData {
    return { endPoints: [this.startPoint] }
  }
}
